module.exports = __webpack_public_path__ + "img/FHQ_logo_white.57df834b.png";